<app-layout-crud-index table>
  <div fxLayout="column" table fxLayoutAlign="space-between center" fxFill
    class="container-padding">
    <button type="button" class="customer-back-link" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      Voltar para clientes
    </button>

    <div class="customer-page-header">
      <div class="customer-title-row">
        <div>
          <span class="customer-context">{{ customerContext }}</span>
          <h1>{{ customerHeading }}</h1>
          <p>{{ customerSubtitle }}</p>
        </div>
        <div class="customer-header-actions">
          <app-input [config]="getFieldConfig('isActive')" [typeCes]="typeCes"
            [group]="form"></app-input>
          <img *ngIf="customerHeaderImage"
            class="customer-header-photo"
            [src]="customerHeaderImage"
            alt="Foto do cliente" />
        </div>
      </div>
    </div>

    <div class="customer-workspace">
      <aside class="customer-section-nav" aria-label="Seções do cliente">
        <div class="customer-nav-heading">
          <strong>{{ typeCes === typeCesEnum.NEW ? 'Etapas do cadastro' : 'Dados do cliente' }}</strong>
          <span>Seção {{ sectionTabIndex + 1 }} de {{ customerSections.length }}</span>
        </div>
        <button type="button" *ngFor="let item of customerSections; let i = index"
          [class.active]="sectionTabIndex === i"
          (click)="selectCustomerSection(i)">
          <span class="customer-nav-index">{{ i + 1 }}</span>
          <span>
            <strong>{{ item.label }}</strong>
            <small>{{ item.description }}</small>
          </span>
        </button>
      </aside>

      <section class="customer-section-panel">
    <mat-tab-group class="customer-tabs" [(selectedIndex)]="sectionTabIndex" mat-align-tabs="start">
      <mat-tab *ngFor="let item of customerSections" [label]="item.label"></mat-tab>
    </mat-tab-group>

    <div class="tabs-content" fxFlex fxLayout="row" fxLayout.lt-md="column" fxFill fxLayoutGap="8"
      fxLayoutGap.lt-md="16">

      <!-- Aba 0: Cadastro | Aba 2: Planos -->
      <div *ngIf="isSection('cadastro') || isSection('planos')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8" class="section-column-fill">

        <mat-card *ngIf="isSection('cadastro')" class="section-card-fill customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Cadastro</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="column" fxLayoutGap="4">
              <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8">
                <app-input class="image-container" fxFlex="20" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('image')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>

                <div fxFlex="80" fxFlex.lt-sm="100" fxLayout="column" fxLayoutGap="4">

                  <div *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_FISICA)"
                    class="cadastro-grid"
                    [class.cadastro-grid-4]="typeCes !== typeCesEnum.NEW"
                    [class.cadastro-grid-3]="typeCes === typeCesEnum.NEW">
                    <app-input
                      [config]="getFieldConfig('code')"
                      [typeCes]="typeCes"
                      *ngIf="typeCes !== typeCesEnum.NEW"
                      [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('legalPersonality')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('cpf')" [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('birthday')" [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>

                  <div *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_JURIDICA)"
                    class="cadastro-grid"
                    [class.cadastro-grid-4]="typeCes !== typeCesEnum.NEW"
                    [class.cadastro-grid-3]="typeCes === typeCesEnum.NEW">
                    <app-input
                      [config]="getFieldConfig('code')"
                      [typeCes]="typeCes"
                      *ngIf="typeCes !== typeCesEnum.NEW"
                      [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('legalPersonality')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('birthday')" [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('cnpj')" [typeCes]="typeCes"
                      [group]="form"
                      (onChange)="onChangeCnpj()"></app-input>
                  </div>

                  <div class="subsection">
                    <div class="subsection-header">
                      <mat-icon>badge</mat-icon>
                      <span>Identificação</span>
                    </div>
                    <div class="subsection-body">
                  <div class="cadastro-grid cadastro-grid-2">
                    <app-input
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_FISICA)"
                      [config]="getFieldConfig('name')" [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_JURIDICA)"
                      [config]="getFieldConfig('companyName')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('tradingName')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>

                  <div *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_FISICA)"
                    class="cadastro-grid cadastro-grid-2">
                    <app-input
                      [config]="getFieldConfig('generalRegistration')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('contributorType')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>

                  <div *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_JURIDICA)"
                    class="cadastro-grid cadastro-grid-3">
                    <app-input
                      [config]="getFieldConfig('stateRegistration')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('municipalRegistration')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('contributorType')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                    </div>
                  </div>

                  <div class="subsection">
                    <div class="subsection-header">
                      <mat-icon>call</mat-icon>
                      <span>Contato</span>
                    </div>
                    <div class="subsection-body">
                  <div class="cadastro-grid cadastro-grid-4">
                    <app-input
                      [config]="getFieldConfig('cellPhone')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('phone')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('email')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input
                      [config]="getFieldConfig('webSite')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="isSection('planos')" class="panel-3 section-card-fill customer-section-scroll-card" fxLayout="column">
          <mat-card-header>
            <mat-card-title>Planos</mat-card-title>
          </mat-card-header>
          <mat-card-content fxFlex="100" fxLayout="column" fxLayoutGap="4">
            <app-customer-plan-items fxFlexFill [typeCes]="typeCes"
              [partnerSelectedFire]="partnerSelectedFire"
              [dataSource]="customerPlansIn"
              [selectedPartnerIds]="getSelectedPartnerIds()"
              (dataSourceChange)="setCustomerPlansOut($event)"
              (hasPendingPlanChange)="onPendingPlanChange($event)">
            </app-customer-plan-items>
          </mat-card-content>
        </mat-card>
      </div>

      <div *ngIf="isSection('filial')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Filial</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-customer-branches-panel
              [branches]="branches"
              [typeCes]="typeCes"
              (branchesChange)="branches = $event">
            </app-customer-branches-panel>
          </mat-card-content>
        </mat-card>
      </div>

      <div *ngIf="isSection('responsavel')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Responsável</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-customer-responsibles-panel
              [customerId]="data?.id"
              [typeCes]="typeCes"
              [branches]="branches"
              [drafts]="responsibleDrafts"
              (draftsChange)="responsibleDrafts = $event">
            </app-customer-responsibles-panel>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Endereço -->
      <div *ngIf="isSection('endereco')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Endereço</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="address-fields" fxLayout="column" fxLayoutGap="4">
              <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8" fxLayoutGap.lt-sm="4">
                <app-input fxFlex="10" fxFlex.lt-md="20" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('cep')"
                  [typeCes]="typeCes" [group]="form"
                  (onChange)="onChangeCep()"></app-input>
                <app-input fxFlex fxFlex.lt-sm="100"
                  [config]="getFieldConfig('address')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
                <app-input fxFlex="10" fxFlex.lt-md="20" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('addressNumber')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>
              <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8" fxLayoutGap.lt-sm="4">
                <app-input-text fxFlex fxFlex.lt-sm="100"
                  [config]="getFieldConfig('addressComplement')"
                  [group]="form"></app-input-text>
                <app-input-text fxFlex="25" fxFlex.lt-md="40" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('neighborhood')"
                  [group]="form"></app-input-text>
              </div>
              <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8" fxLayoutGap.lt-sm="4">
                <app-input fxFlex="15" fxFlex.lt-md="30" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('state')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="onChangeState($event)"></app-input>
                <app-input fxFlex="25" fxFlex.lt-md="40" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('city')"
                  [typeCes]="typeCes" [group]="form"></app-input>
                <app-input fxFlex="15" fxFlex.lt-md="30" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('country')"
                  [typeCes]="typeCes" [group]="form"></app-input>
                <app-input-text class="address-observation" fxFlex fxFlex.lt-sm="100"
                  [config]="getFieldConfig('addressObservation')"
                  [group]="form"></app-input-text>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Aba 3: Comissões | Aba 4: Contratos -->
      <div *ngIf="isSection('comissoes') || isSection('contratos')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">

        <mat-card *ngIf="isSection('comissoes')" class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Comissões</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxFlex fxLayout="column" fxLayoutGap="6">
              <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="2"
                fxLayoutGap.lt-sm="4">
                <app-input fxFlex [config]="getFieldConfig('consultant')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectConsultant($event)"></app-input>
                <app-input fxFlex="25" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('consultantCommission')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>

              <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="2"
                fxLayoutGap.lt-sm="4">
                <app-input fxFlex [config]="getFieldConfig('partner')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectPartner($event)"></app-input>
                <app-input fxFlex="25" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('partnerCommission')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>

              <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="2"
                fxLayoutGap.lt-sm="4">
                <app-input fxFlex [config]="getFieldConfig('representative')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectRepresentative($event)"></app-input>
                <app-input fxFlex="25" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('representativeCommission')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>

              <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="2"
                fxLayoutGap.lt-sm="4">
                <app-input fxFlex [config]="getFieldConfig('counter')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectCounter($event)"></app-input>
                <app-input fxFlex="25" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('counterCommission')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>

              <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="2"
                fxLayoutGap.lt-sm="4">
                <app-input fxFlex [config]="getFieldConfig('unit')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="selectUnit($event)"></app-input>
                <app-input fxFlex="25" fxFlex.lt-sm="100"
                  [config]="getFieldConfig('unitCommission')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="isSection('contratos')" class="items-contract customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Contratos</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-customer-contracts-panel
              [customer]="data"
              [typeCes]="typeCes">
            </app-customer-contracts-panel>
            <div class="documents-title">DOCUMENTOS</div>
            <div class="documents-grid">
              <div class="contract-item">
                <app-input [config]="getFieldConfig('contract')"
                  [typeCes]="isAllowChangeContract()"
                  [group]="form"
                  (onFileClick)="openFileLink($event)"
                  (onFileDelete)="confirmDeleteFile($event, 'contract')"></app-input>
              </div>
              <div class="contract-item">
                <app-input
                  [config]="getFieldConfig('digitalCertificate')"
                  [typeCes]="isAllowChangeDigitalCertificate()"
                  [group]="form"
                  (onFileClick)="openFileLink($event)"
                  (onFileDelete)="confirmDeleteFile($event, 'digitalCertificate')"></app-input>
              </div>
              <div class="contract-item">
                <app-input [config]="getFieldConfig('lastBackup')"
                  [typeCes]="isAllowChangeLastBackup()"
                  [group]="form"
                  (onFileClick)="openFileLink($event)"
                  (onFileDelete)="confirmDeleteFile($event, 'lastBackup')"></app-input>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Aba 5: OS -->
      <div *ngIf="isSection('os')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>OS</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-customer-os-list [customerId]="data?.id"></app-customer-os-list>
          </mat-card-content>
        </mat-card>
      </div>

      <div *ngIf="isSection('parametros')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Parâmetros</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8"
              fxLayoutGap.lt-sm="4">
              <app-input fxFlex [config]="getFieldConfig('externalCode')"
                [typeCes]="typeCes" [group]="form"></app-input>
              <app-input fxFlex [config]="getFieldConfig('accessQuantity')"
                [typeCes]="typeCes" [group]="form"></app-input>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div *ngIf="isSection('acessos')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Acessos</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-customer-accesses-panel [customerId]="data?.id"></app-customer-accesses-panel>
          </mat-card-content>
        </mat-card>
      </div>

      <div *ngIf="isSection('cobrancas')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card">
          <mat-card-header>
            <mat-card-title>Cobranças</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-customer-charges-panel [customerId]="data?.id"></app-customer-charges-panel>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Aba 6: Fiscal -->
      <div *ngIf="isSection('fiscal')"
        fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="8">
        <mat-card class="items customer-section-scroll-card fiscal-card">
          <mat-card-header>
            <mat-card-title>Fiscal</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="fiscal-section">
              <div class="fiscal-customer-grid">
                <app-input class="span-3" [config]="getFieldConfig('regime')"
                  [typeCes]="typeCes" [group]="form"></app-input>
                <app-input class="span-3" [config]="getFieldConfig('mainActivity')"
                  [typeCes]="typeCes" [group]="form"></app-input>
                <app-input class="span-2" [config]="getFieldConfig('fiscalEnvironment')"
                  [typeCes]="typeCes" [group]="form"></app-input>
                <ng-container
                  *ngIf="form.get('fiscalEnvironment')?.getRawValue() === fiscalEnvironmentEnum.PRODUCTION">
                  <app-input class="span-2" [config]="getFieldConfig('csc')"
                    [typeCes]="typeCes" [group]="form"></app-input>
                  <app-input class="span-2" [config]="getFieldConfig('cscId')"
                    [typeCes]="typeCes" [group]="form"></app-input>
                </ng-container>
              </div>
              <app-customer-fiscal-parameters-panel
                [branches]="branches"
                [typeCes]="typeCes"
                (branchesChange)="branches = $event">
              </app-customer-fiscal-parameters-panel>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

    </div>
      </section>
    </div>

    <div class="action-footer" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="end center"
      fxLayoutAlign.lt-md="center center"
      style="width: 100%; margin-top: auto;" fxLayoutGap="8"
      fxLayoutGap.lt-md="4">
      <div fxFlex="initial" fxFlex.lt-sm="100" class="info-title">DATA
        CADASTRO</div>
      <div fxFlex="initial" fxFlex.lt-sm="100" class="info-value">
        {{ getCreatedAt() | date : "dd/MM/yyyy HH:mm" }}
      </div>
      <ng-container *ngIf="typeCes === typeCesEnum.EDIT">
        <app-input class="dateEdit" fxFlex="1" fxFlex.lt-sm="100"
          [config]="getFieldConfig('createdAt')" [typeCes]="typeCes"
          [group]="form">
        </app-input>
      </ng-container>

      <div fxFlex.lt-sm="100" fxHide.lt-sm>|</div> &nbsp;
      <div fxFlex="initial" fxFlex.lt-sm="100" class="info-title">ÚLTIMA
        ALTERAÇÃO</div>
      <div fxFlex="initial" fxFlex.lt-sm="100" class="info-value">
        {{ getUpdatedAt() | date : "dd/MM/yyyy HH:mm" }}
      </div>
      <ng-container *ngIf="typeCes === typeCesEnum.EDIT">
        <app-input class="dateEdit" fxFlex="1" fxFlex.lt-sm="100"
          [config]="getFieldConfig('updatedAt')" [typeCes]="typeCes"
          [group]="form">
        </app-input>
      </ng-container>
      <div fxFlex.lt-sm="100" fxHide.lt-sm>|</div> &nbsp;
      <div fxFlex="initial" fxFlex.lt-sm="100">
        <button matRipple class="pdf-button">
          <mat-icon>picture_as_pdf</mat-icon>
        </button>
      </div>

      <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8"
        fxLayoutGap.lt-sm="4" fxLayoutAlign="end center"
        fxLayoutAlign.lt-sm="stretch" fxFlex.lt-sm="100">
        <button class="custom-button" type="button" (click)="back()"
          mat-raised-button fxFlex.lt-sm>
          VOLTAR
        </button>
        <button *ngIf="typeCes !== typeCesEnum.SHOW"
          class="custom-button btn-save" type="submit" variant="contained"
          mat-raised-button [disabled]="form.invalid || hasPendingPlan"
          (click)="save()" fxFlex.lt-sm>
          SALVAR
        </button>
        <button
          *ngIf="typeCes === typeCesEnum.SHOW && permissionService.is(permissionService.systemActionRoles.CUSTOMER_REGISTRATION_EDIT_BUTTON_SHOW)"
          [disabled]="!permissionService.is(permissionService.systemActionRoles.CUSTOMER_REGISTRATION_EDIT_BUTTON_ENABLE)"
          class="custom-button btn-edit" type="submit" variant="contained"
          mat-raised-button (click)="edit()" fxFlex.lt-sm>
          EDITAR
        </button>
      </div>
    </div>
  </div>
</app-layout-crud-index>
